import { Typography, styled } from "@mui/material";
import * as React from "react";
import { ButtonColor } from "../../config";
import Sys from "../../core/Sys";
import Button from "../../coreui/Button";
import Dialog from "../../coreui/Dialog";
import DialogActions from "../../coreui/DialogActions";
import DialogContent from "../../coreui/DialogContent";
import Icon from "../../coreui/Icon";
import Grid from "../../mustangui/Grid";
import GridItem from "../../mustangui/GridItem";

interface Props {
  cancelButtonText: string;
  continueButtonAlternateText?: string;
  continueButtonColor: ButtonColor;
  continueButtonIcon?: string;
  continueButtonIsIconOnly?: boolean;
  continueButtonText: string;
  isOpen: boolean;
  message: string;
  onCancel: () => void;
  onContinue: () => void;
  title: string;
}

const ConfirmationDialogActions = styled(DialogActions)({
  justifyContent: "space-between",
});

export class ConfirmationDialog extends React.Component<Props> {
  private readonly componentId: string;
  private readonly continueButtonDescriptionId: string;
  private readonly messageId: string;
  private readonly titleId: string;

  public constructor(props: Props) {
    super(props);

    this.componentId = `confirmation-dialog-${Sys.nextId}`;
    this.continueButtonDescriptionId = `${this.componentId}-continue-button-description`;
    this.messageId = `${this.componentId}-message`;
    this.titleId = `${this.componentId}-title`;
  }

  public render() {
    const isDanger: boolean = this.props.continueButtonColor === "danger";

    return (
      <Dialog
        aria-describedby={this.messageId}
        aria-labelledby={this.titleId}
        fullScreen={false}
        id={this.componentId}
        onClose={() => this.props.onCancel()}
        open={this.props.isOpen}
        role="alertdialog"
      >
        <DialogContent>
          <Grid grouping="Closely Related" lg={1} md={1} sm={1} xs={1}>
            <GridItem xl={1} lg={1} md={1} sm={1} xs={1}>
              <Typography
                id={this.titleId}
                sx={{
                  color: isDanger ? "danger.main" : undefined,
                }}
                variant="h3"
              >
                {isDanger ? (
                  <div
                    style={{
                      display: "inline-block",
                      height: "1em",
                      marginRight: ".4em",
                      width: "1em",
                    }}
                  >
                    <Icon
                      fixedWidth
                      icon="far fa-octagon-exclamation"
                      style={{ display: "inline" }}
                    />
                  </div>
                ) : null}
                {this.props.title}
              </Typography>
            </GridItem>
            <GridItem xl={1} lg={1} md={1} sm={1} xs={1}>
              <Typography id={this.messageId}>{this.props.message}</Typography>
            </GridItem>
          </Grid>
        </DialogContent>
        <ConfirmationDialogActions>
          <Button
            aria-describedby={
              this.props.continueButtonIsIconOnly
                ? this.continueButtonDescriptionId
                : undefined
            }
            aria-label={
              this.props.continueButtonIsIconOnly
                ? this.props.continueButtonText
                : undefined
            }
            autoFocus
            color={this.props.continueButtonColor}
            icon={this.props.continueButtonIcon}
            label={
              !this.props.continueButtonIsIconOnly
                ? this.props.continueButtonText
                : undefined
            }
            onClick={() => this.props.onContinue()}
          />
          {this.props.continueButtonAlternateText ? (
            <div
              id={this.continueButtonDescriptionId}
              style={{ display: "none" }}
            >
              {this.props.continueButtonAlternateText}
            </div>
          ) : null}
          <Button
            onClick={() => this.props.onCancel()}
            style={{ marginLeft: 40 }}
          >
            {this.props.cancelButtonText}
          </Button>
        </ConfirmationDialogActions>
      </Dialog>
    );
  }
}

export default ConfirmationDialog;
